export default "__VITE_ASSET__Cg3OEe9K__"